import { IPrefixSuffix } from "src/app/shared/models/IPrefixSuffix";

export class ClinicialUtility {
    static createPatientDeviceSearch(searchPatientDeviceValue: string, prefixSuffixData: IPrefixSuffix, modelsRegex: string[]): string[] {
        if (prefixSuffixData && prefixSuffixData.id > 0) {
            return this.removePrefixSuffix(searchPatientDeviceValue, prefixSuffixData, modelsRegex);
        } else {
            return [searchPatientDeviceValue];
        }
    }
    static removePrefixSuffix(params: string, prefixSuffixData: IPrefixSuffix, modelsRegex: string[]): string[] {
        var barcode = params;
        var length = barcode.length - prefixSuffixData.scannerSufffix.length;
        var length1 = barcode.length - prefixSuffixData.scannerSufffix.length;
        var lastEnteredValue = "";
        for (var i = barcode.length; i > length; i--) {
            lastEnteredValue += barcode[length1];
            length1++;
        }
        length = barcode.length;
        if (barcode.indexOf(prefixSuffixData.scannerPrefix) == 0) {
            barcode = barcode.substring(prefixSuffixData.scannerPrefix.length)
        }
        length = barcode.length - prefixSuffixData.scannerSufffix.length;
        if (lastEnteredValue == prefixSuffixData.scannerSufffix) {
            barcode = barcode.substring(0, length);
        }
        params = barcode;
        if (modelsRegex.find(regex => new RegExp(regex).test(barcode.trim()))) {
            return [barcode];
        }
        if (prefixSuffixData.devicePrefix || prefixSuffixData.deviceSufffix) {
            // remove device prefix and suffix
            length = barcode.length;
            if (barcode.indexOf(prefixSuffixData.devicePrefix) == 0) {
                barcode = barcode.substring(prefixSuffixData.devicePrefix.length)
            }
            length = barcode.length - prefixSuffixData.deviceSufffix.length;
            var length2 = barcode.length - prefixSuffixData.deviceSufffix.length;
            lastEnteredValue = "";
            for (var i = barcode.length; i > length; i--) {
                lastEnteredValue += barcode[length2];
                length2++;
            }
            if (lastEnteredValue == prefixSuffixData.deviceSufffix) {
                barcode = barcode.substring(0, length);
            }
        }
        params = barcode;
        if (prefixSuffixData.patientPrefix
            || prefixSuffixData.patientSufffix
            || prefixSuffixData.patientSearchDelimeter) {
            // remove patient prefix and suffix
            length = barcode.length;
            if (barcode.indexOf(prefixSuffixData.patientPrefix) == 0) {
                barcode = barcode.substring(prefixSuffixData.patientPrefix.length)
            }
            length = barcode.length - prefixSuffixData.patientSufffix.length;
            var length3 = barcode.length - prefixSuffixData.patientSufffix.length;
            lastEnteredValue = "";
            for (var i = barcode.length; i > length; i--) {
                lastEnteredValue += barcode[length3];
                length3++;
            }
            if (lastEnteredValue == prefixSuffixData.patientSufffix) {
                barcode = barcode.substring(0, length);
            }
            if (prefixSuffixData.patientSearchDelimeter.length > 0) {
                return barcode.split(prefixSuffixData.patientSearchDelimeter);
            }
        }
        return [barcode];
    }
}